<template>
    <div id="app">
        <mHead :datasrc="dataSrc" :recruittype="recruitType"></mHead>

        <div class="msg">
            <transition name="custom-classes-transition" enter-active-class="animated flipInX">
                <p v-if="msgShow">{{msg}}</p>
            </transition>
            <!-- <p v-if="msgShow">{{msg}}</p> -->
        </div>
        <!-- <transition name="custom-classes-transition" enter-active-class="animated fadeInRight"> -->
            <router-view @msgShowFn="msgShowFn" :datasrc="dataSrc" :recruittype="recruitType" />
        <!-- </transition> -->
        <mFoot></mFoot>
    </div>
</template>

<script>
import mHead from '@/components/mhead'
import mFoot from '@/components/mfoot'
export default {
    name: 'app',
    data(){
        return{
            msg:'',
            msgShow:false,
            msgTimer:null,
            dataSrc:{},
            recruitType:[]
        }
    },
    components: {
        mHead,
        mFoot
    },
    created(){
        this.recruitTypeFn();
    },
    mounted () {  
        const script = document.createElement('script')  
        script.src = 'https://s95.cnzz.com/z_stat.php?id=1260088808&web_id=1260088808'  
        script.language = 'JavaScript'  
        document.body.appendChild(script)  
    },
    watch: {
        '$route' () {  
            if (window._czc) {  
                let location = window.location  
                let contentUrl = location.pathname + location.hash  
                let refererUrl = '/'  
                window._czc.push(['_trackPageview', contentUrl, refererUrl])  
            }
        }
    },
    methods:{
        /**父组件方法，子组件可通过this.$emit('msgShowFn') */
        msgShowFn(msg){
            if (this.msgTimer == null) {
                this.msg = msg;
                this.msgShow = true;
                this.msgTimer = setTimeout(() => {
                    this.msgShow = false;
                    this.msgTimer = null;
                }, 1200);
            }
        },
        /**招聘类型数据放置 */
        recruitTypeFn(){
            this.$http({
                method:'post',
                url:this.basePath+'/f/recruitTypeList'
            }).then(response => {
                
                this.recruitType = response.data;
                this.recruitType.map((el,i)=>{
                    this.dataSrc[el.id] = el.logo;
                });
                
            },response => {
                console.log('获取数据失败');
                console.log(response);
            })
        }
    }
}
</script>

<!-- lang="less"后 可编写less ，默认的cli无less-loader包，需自行安装 -->
<style lang="less">
#app{
    padding-top: 70px;
}
.msg{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    z-index: 200;
    p{
        background-color: rgba(0, 0, 0, 0.8);
        padding: 5px 20px;
        font-size: 12px;
        border-radius: 10px;
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue